import React, { Suspense, lazy, memo } from "react";
import { Routes, Route } from "react-router-dom";
import MiniDrawer from "./common/Drawer";
import isUserLoggedIn from "./features/authentication/isLoggedIn";
import { Loader } from "./common/loading";

const DashboardMain = lazy(() => import("./features/dashboard/dashboardMain"));
const Bank = lazy(() => import("./features/bank/bank"));
const AuthorityManagementMain = lazy(() => import("./features/authorityManagement/authorityManagementMain"));

const QuestionBank = lazy(() => import("./features/contentDeveloper/questionBank"));
const CreateQuestion = lazy(() => import("./features/contentDeveloper/createQuestion"));
const QuestionDetail = lazy(() => import("./features/contentDeveloper/questionDetail"));
const EditQuestion = lazy(() => import("./features/contentDeveloper/editQuestion"));

const Profile = lazy(() => import("./features/profile/profile"));
const ExamMain = lazy(() => import("./features/exams/examsMain"));
const Announcement = lazy(() => import("./features/announcement/announcement"));
const RewardNested = lazy(() => import("./features/rewards/rewardNested"));
const Marketing = lazy(() => import("./features/marketing/marketing"));
const InterestMain = lazy(() => import("./features/interestGroups.js/interestMain"));
const EntityMain = lazy(() => import("./features/entity/entityMain"));
const DataManagementMain = lazy(() => import("./features/dataManagement/dataManagementMain"));
const UserMain = lazy(() => import("./features/userManagement/userMain"));
const FeedMain = lazy(() => import("./features/feedAlgo/feedMain"));
const NestedDoubt = lazy(() => import("./features/doubtManagement/nestedDoubt"));
const SalesMain = lazy(() => import("./features/sales/main"));
const BlogsMain = lazy(() => import("./features/blogs/blogsMain"));
const UploadFile = lazy(() => import("./features/imageUpload/uploadImage"));
const Session = lazy(() => import("./features/session/session"));
const Mock = lazy(() => import("./features/mock/mock"));
const SessionClass = lazy(() => import("./features/sessionClass/sessionClass"));
const SessionClassMain = lazy(() => import("./features/sessionClass/main"));
const ClassDetail = lazy(() => import("./features/entity/class/detail/classDetail"));
const EventsRoute = lazy(() => import("./features/events/eventsRoute"));
const AllEvent = lazy(() => import("./features/events/allEvent"));
const DailyStreakRoutes = lazy(() => import("./features/dailyStreak/dailyStreakRoutes"));
const VideoBankMain = lazy(() => import("./features/videoBank/VideoBankRoutes"));
const NoteBankMain = lazy(() => import("./features/noteBank/noteBankRoutes"));
const RolesManagementMain = lazy(() => import("./features/rolesManagement/rolesManagementMain"));
const StudentMain = lazy(() => import("./features/studentManagement/studentMain"));
const Logs = lazy(() => import("./features/logs/logs"));

function Main() {
  const [open, setOpen] = React.useState(false);
  return (
    <div>
      <MiniDrawer open={open} setOpen={setOpen} />
      <main className={` w-screen background h-screen overflow-auto transition-transform duration-200 ease-in-out will-change-transform
             ${open ? "translate-x-[240px]" : "translate-x-[64px]"}`}
        style={{   width: open ? "calc(100vw - 240px)" : "calc(100vw - 64px)" }}
        
      >

        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/dashboard" element={<DashboardMain />} />

            <Route path="/bank/*" element={<Bank />} />
            <Route path="/management/*" element={<AuthorityManagementMain />} />

            <Route path="/content-management" element={<QuestionBank />} />
            <Route path="/content-management/create" element={<CreateQuestion />} />
            <Route path="/content-management/:qid" element={<QuestionDetail />} />
            <Route path="/content-management/:qid/edit" element={<EditQuestion />} />

            <Route path="/profile" element={<Profile />} />
            <Route path="exam/*" element={<ExamMain />} />
            <Route path="announcement/*" element={<Announcement />} />
            {/* <Route path="rewards/*" element={<RewardsMain />} /> */}
            <Route path="rewards/*" element={<RewardNested />} />

            <Route path="marketing/*" element={<Marketing />} />

            <Route path="interest/groups/*" element={<InterestMain />} />
            <Route path="entity/*" element={<EntityMain />} />
            <Route path="data/*" element={<DataManagementMain />} />

            <Route path="user/*" element={<UserMain />} />
            {/* <Route path="faq/*" element={<FaqMain />} /> */}
            <Route path="feed/*" element={<FeedMain />} />
            {/* <Route path="doubt/*" element={<Index />} /> */}
            <Route path="doubt-management/*" element={<NestedDoubt />} />
            <Route path="sales/*" element={<SalesMain />} />
            <Route path="blogs/*" element={<BlogsMain />} />
            <Route path="upload/image/*" element={<UploadFile />} />
            <Route path="session/*" element={<Session />} />
            <Route path="mock/*" element={<Mock />} />
            <Route path="session-class/*" element={<SessionClass />} />
            <Route path="session-class/create" element={<SessionClassMain />} />
            <Route path="session-class/edit/:classId" element={<SessionClassMain />} />
            <Route path="session-class/details/:classId" element={<ClassDetail />} />

            <Route path="events/*" element={<EventsRoute />} />
            <Route path="event/*" element={<AllEvent />} />
            <Route path="dailyStreak/*" element={<DailyStreakRoutes />} />
            <Route path="video/bank/*" element={<VideoBankMain />} />
            <Route path="note/bank/*" element={<NoteBankMain />} />
            <Route path="roles/*" element={<RolesManagementMain />} />
            <Route path="student/*" element={<StudentMain />} />
            <Route path="logs" element={<Logs />} />

            {/* <Route path="change/password" element={<ChangePassword />} /> */}
          </Routes>
        </Suspense>
      </main>
    </div>
  );
}

// export default isUserLoggedIn(Main);
export default memo(isUserLoggedIn(Main));
